import template from './liability.html'
import controller from './liability.controller'
import './liability.scss'

const reportingComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default reportingComponent;


// WEBPACK FOOTER //
// ./client/app/components/reporting/components/liability/liability.component.js